import React, { useState, useEffect } from "react";
import "../App.css";
import { useHistory, useLocation } from "react-router-dom";
import { FormGroup, Button } from "reactstrap";
import user from "../assets/user.png";
import MyLoader from "./util/loader";
import MyStorage from "./util/storage";
import Api from "./api/api";
import showToast from "./util/toast";
import { ToastContainer } from "react-toastify";
import "reactjs-popup/dist/index.css";
import MyPopup from "./util/popup";
import CustomPicker from "./util/custom_picker";

const AssignPrograms = () => {
  var history = useHistory();

  let filePath = MyStorage.getFileUrls().SpecialProgram;

  const [tab, setTab] = useState(0);
  const [chooser1, setChooser1] = useState(0);
  const [chooser2, setChooser2] = useState(0);
  const [selectedVideos, setSelectedVideos] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [recepients, setRecepients] = useState("");
  const [members, setMembers] = useState([]);
  const [requests, setRequests] = useState([]);
  const [newRequests, setNewRequests] = useState(false);

  //   const [showError, setShowError] = useState(false);
  //   const [error, setError] = useState("");
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    // loadFilters()
    loadRequests();
  }, []);

    const [users, setUsers] = useState([]);

    useEffect(() => {
      Api.getUsers(1, (data) => {
        setUsers(data.data);
      });
    }, []);

  const loadRequests = () => {
    setLoader(true);
    Api.getRecommendationRequests(
      (response) => {
        setLoader(false);
        console.log(response.data)
        setRequests(response.data);
        for (let i = 0; i < response.data.length; i++) {
          const item = response.data[i];
          if (item.admin_read === null || item.admin_read === 0) {
            setNewRequests(true);
            break;
          }
        }
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  const updateAdminReadAll = () => {
    Api.updateAdminReadRequests(
      (response) => {
        console.log(JSON.stringify(response));
      },
      (error) => {
        console.log(JSON.stringify(error));
      }
    );
  };

  const loadMembers = () => {
    setLoader(true);
    Api.getSpecialProgramMembers(
      (response) => {
        setLoader(false);
        // console.log('members: ' + JSON.stringify(response));
        // group
        let members = [];
        for (let i = 0; i < response.data.length; i++) {
          let member = response.data[i];
          if (member.user != null) {
            members.push(member);
          }
        }
        let groups = groupItems(members);
        setMembers(groups);
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  const groupItems = (items) => {
    console.log("groupItems");
    const memo = items.reduce((memo, object) => {
      if (object.user === null || object.user === undefined) {
        console.log("USER NULL");
      }
      if (object.user.id in memo) memo[object.user.id].push(object);
      else memo[object.user.id] = [object];
      return memo;
    }, {});
    let models = [];
    Object.keys(memo).reduce((a, key) => {
      const objects = memo[key].sort();
      let model = {
        groupUserId: key,
        ...objects[0].user,
      };
      models = models.concat(model);
    }, []);
    return models;
  };

  const resetData = () => {
    setSelectedCategories([]);
    setSelectedVideos([]);
    setRecepients("");
  };

  const assignData = () => {
    if (selectedVideos.length === 0 && selectedCategories.length === 0) {
      return;
    }
    if (recepients === "") {
      return;
    }

    let videoIds = "";
    for (let i = 0; i < selectedVideos.length; i++) {
      const vid = selectedVideos[i];
      if (i < selectedVideos.length - 1) videoIds = videoIds + vid.id + ",";
      else videoIds = videoIds + vid.id;
    }

    let catIds = "";
    for (let i = 0; i < selectedCategories.length; i++) {
      const cat = selectedCategories[i];
      if (i < selectedCategories.length - 1) catIds = catIds + cat.id + ",";
      else catIds = catIds + cat.id;
    }

    setLoader(true);
    let type = chooser2 === 0 ? "category" : "video";
    Api.addMembers(
      type,
      catIds,
      videoIds,
      recepients,
      (response) => {
        setLoader(false);
        showToast("success", "Assigned!");
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  const showSelectedVideos = () => {
    if (selectedVideos.length === 0) return "Choose Video(s)";
    let videos = "";
    for (let i = 0; i < selectedVideos.length; i++) {
      const vid = selectedVideos[i];
      if (i < selectedVideos.length - 1) videos = videos + vid.id + ",";
      else videos = videos + vid.id;
    }
    if (videos === "") return "Choose Video(s)";
    return videos;
  };

  const showSelectedCategories = () => {
    let cats = "";
    for (let i = 0; i < selectedCategories.length; i++) {
      const cat = selectedCategories[i];
      if (i < selectedCategories.length - 1) cats = cats + cat.id + ",";
      else cats = cats + cat.id;
    }
    if (cats === "") return "Choose Category(s)";
    return cats;
  };

  const showVideosPicker = () => {
    return (
      <FormGroup style={{ marginTop: 15 }}>
        <CustomPicker
          key={"" + chooser1}
          library_type={chooser1 === 0 ? "special" : "library"}
          type="video"
          title={"Select Videos"}
          selectedVideos={selectedVideos}
          onDone={(videos) => {
            console.log("selected: " + JSON.stringify(videos));
            setSelectedVideos(videos);
          }}
          button={
            <div
              style={{
                display: "flex",
                paddingLeft: 10,
                marginTop: 5,
                backgroundColor: "white",
                border: "1px solid lightgray",
                borderRadius: 5,
                borderColor: "lightgray",
              }}
            >
              <div
                style={{
                  alignSelf: "center",
                  color: "gray",
                  padding: 8,
                  fontSize: 16,
                }}
              >
                {showSelectedVideos()}
              </div>
            </div>
          }
        />
      </FormGroup>
    );
  };

  const showCatsPicker = () => {
    return (
      <FormGroup style={{ marginTop: 15 }}>
        <CustomPicker
          key={"" + chooser1}
          library_type={chooser1 === 0 ? "special" : "library"}
          type="category"
          selectedCategories={selectedCategories}
          title={"Select Categories"}
          onDone={(categories) => {
            console.log("selected categories: " + JSON.stringify(categories));
            setSelectedCategories(categories);
          }}
          button={
            <div
              style={{
                display: "flex",
                paddingLeft: 10,
                marginTop: 5,
                backgroundColor: "white",
                border: "1px solid lightgray",
                borderRadius: 5,
                borderColor: "lightgray",
              }}
            >
              <div style={{ alignSelf: "center", color: "gray", padding: 8 }}>
                {showSelectedCategories()}
              </div>
            </div>
          }
        />
      </FormGroup>
    );
  };

  const showUsersPicker = () => {
    return (
      <FormGroup
        style={{ marginTop: 10, display: "flex", alignItems: "center" }}
      >
        <MyPopup
          collect="id"
          title={"Select Users"}
          models={users}
          onDone={(users) => {
            // label, value (email)
            console.log("selected: " + JSON.stringify(users));
            let ids = "";
            for (let i = 0; i < users.length; i++) {
              const user = users[i];
              if (i < users.length - 1) ids = ids + user.value + ",";
              else ids = ids + user.value;
            }
            setRecepients(ids);
          }}
          button={
            <div
              style={{
                width: "100%",
                display: "flex",
                paddingLeft: 10,
                marginTop: 5,
                backgroundColor: "white",
                border: "1px solid lightgray",
                borderRadius: 5,
                borderColor: "lightgray",
              }}
            >
              <div
                style={{
                  alignSelf: "center",
                  color: "gray",
                  padding: 8,
                  fontSize: 16,
                  maxWidth: 500,
                }}
              >
                {recepients === "" ? "Choose Users" : recepients}
              </div>
            </div>
          }
        />
      </FormGroup>
    );
  };

  const showAssign = () => {
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <FormGroup
          style={{ display: "flex", alignItems: "center", marginTop: 20 }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="radio"
              checked={chooser1 === 0}
              onChange={() => {
                setChooser1(0);
                setSelectedCategories([]);
                setSelectedVideos([]);
              }}
            />
            <div style={{ marginLeft: 8, marginRight: 20 }}>
              Special Library
            </div>
            <input
              type="radio"
              checked={chooser1 === 1}
              onChange={() => {
                setChooser1(1);
                setSelectedCategories([]);
                setSelectedVideos([]);
              }}
            />
            <div style={{ marginLeft: 8 }}>Main Library</div>
          </div>
        </FormGroup>
        <FormGroup
          style={{ display: "flex", alignItems: "center", marginTop: 20 }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="radio"
              checked={chooser2 === 0}
              onChange={() => {
                setChooser2(0);
              }}
            />
            <div style={{ marginLeft: 8, marginRight: 20 }}>
              Assign Subcategory
            </div>
            <input
              type="radio"
              checked={chooser2 === 1}
              onChange={() => {
                setChooser2(1);
              }}
            />
            <div style={{ marginLeft: 8 }}>Assign Video</div>
          </div>
        </FormGroup>

        {chooser2 === 0 ? showCatsPicker() : showVideosPicker()}

        {showUsersPicker()}

        <Button
          className="btn-block"
          style={{
            width: 70,
            fontSize: 14,
            height: 40,
            marginTop: 10,
            backgroundColor: "transparent",
            color: "blue",
            border: "0px",
            alignSelf: "center",
          }}
          onClick={resetData}
        >
          Reset
        </Button>

        <Button
          className="btn-block"
          style={{ width: "100%", fontSize: 16, marginTop: 10 }}
          onClick={assignData}
        >
          Assign
        </Button>
      </div>
    );
  };

  const removeMember = (model) => {
    setLoader(true);
    Api.removeMembers(
      model.id,
      (response) => {
        setLoader(false);
        loadMembers();
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  const deleteRequest = (id) => {
    setLoader(true);
    Api.deleteRecommendationRequest(
      id,
      (response) => {
        setLoader(false);
        const list = requests.filter((item, j) => {
          return item.id !== id; //false will delete
        });
        setRequests(list);
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  const getProfilePhoto = (model) => {
    if (
      MyStorage.getFileUrls() === null ||
      model == null ||
      model.photo === null ||
      model.photo === ""
    ) {
      return user;
    } else {
      if (model.photo.includes("http")) {
        return model.photo;
      }
      return MyStorage.getFileUrls().User + model.photo;
    }
  };

  const showAssignedUsers = () => {
    console.log("user: " + JSON.stringify(members[0]));
    return (
      <div style={{ width: "100%", marginTop: 15 }}>
        {members.map((model, index) => {
          let className =
            index % 2 !== 0 ? "projects-itembar" : "projects-itembar-colored";
          return (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div className={className} style={{ marginTop: 0 }}>
                <div className="projects-item-photo">
                  <img
                    src={getProfilePhoto(model)}
                    style={{ padding: 1, width: 70, height: 70 }}
                  />
                </div>
                <div className="projects-item-cat" style={{}}>
                  <div style={{ fontSize: 16 }}>
                    {model.fname + " " + model.lname}
                  </div>
                </div>
                <div
                  className="projects-item-cat"
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  <Button
                    className="btn-block btn-submit"
                    style={{ width: 150, fontSize: 16 }}
                    onClick={() => {
                      console.log("click");
                      history.push({
                        pathname: "/user-details",
                        state: { user: model, assignments: true },
                      });
                    }}
                  >
                    View
                  </Button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const showRequests = () => {
    const requestsFiltered = requests.filter(r => r.user)
    return (
      <div style={{ width: "100%", marginTop: 15 }}>
        {requestsFiltered.map((model, index) => {
          let className =
            index % 2 !== 0 ? "projects-itembar" : "projects-itembar-colored";
          return (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div className={className} style={{ marginTop: 0 }}>
                <div className="projects-item-photo">
                  <img
                    src={getProfilePhoto(model.user)}
                    style={{ padding: 1, width: 70, height: 70 }}
                  />
                </div>
                <div className="projects-item-cat" style={{}}>
                  <div style={{ fontSize: 16 }}>
                    {model.user.fname + " " + model.user.lname}
                  </div>
                  <div style={{ fontSize: 13, color: "black" }}>
                    Age: {model.age.title}
                  </div>
                  <div style={{ fontSize: 13, color: "black" }}>
                    Goal: {model.goal.title}
                  </div>
                  <div style={{ fontSize: 13, color: "black" }}>
                    Status: {model.status.title}
                  </div>
                  <div style={{ fontSize: 13, color: "black" }}>
                    Notes: {model.text}
                  </div>
                </div>

                <div
                  className="projects-item-cat"
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  <Button
                    className="btn-block btn-submit"
                    style={{ width: 100, fontSize: 16 }}
                    onClick={() => {
                      console.log("click");
                      history.push({
                        pathname: "/user-details",
                        state: { user: model.user },
                      });
                    }}
                  >
                    View
                  </Button>
                  <Button
                    style={{
                      width: 100,
                      backgroundColor: "blue",
                      marginLeft: 10,
                      fontSize: 16,
                    }}
                    className="btn-block btn-submit"
                    onClick={() => {
                      console.log("click");
                      setTab(0);
                      setRecepients(model.user.id);
                    }}
                  >
                    Assign
                  </Button>
                  <Button
                    style={{
                      width: 100,
                      backgroundColor: "red",
                      marginLeft: 10,
                      fontSize: 16,
                    }}
                    className="btn-block btn-submit"
                    onClick={() => {
                      console.log("click");
                      deleteRequest(model.id);
                    }}
                  >
                    Delete
                  </Button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="main">
      <div
        className="titlebar"
        style={{ backgroundColor: "#f2f2f2", padding: 10, margin: -15 }}
      >
        <div style={{ color: "blue" }}>Assign Subcats/Videos</div>
      </div>
      <div
        style={{
          marginTop: 20,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            width: 600,
            marginTop: 10,
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <button
              className="btn-block"
              style={{
                color: "white",
                fontSize: 14,
                height: 30,
                backgroundColor: tab === 0 ? "black" : "gray",
                borderWidth: 0,
                width: 250,
                borderBottomLeftRadius: 5,
                borderTopLeftRadius: 5,
              }}
              onClick={() => {
                console.log("click");
                setTab(0);
              }}
            >
              Assign
            </button>
            <button
              className="btn-block"
              style={{
                color: "white",
                fontSize: 14,
                height: 30,
                backgroundColor: tab === 1 ? "black" : "gray",
                borderWidth: 0,
                width: 250,
                borderBottomRightRadius: 0,
                borderTopRightRadius: 0,
              }}
              onClick={() => {
                console.log("click");
                setTab(1);
                loadMembers();
              }}
            >
              Assigned Users
            </button>
            <button
              className="btn-block"
              style={{
                color: "white",
                fontSize: 14,
                height: 30,
                backgroundColor: tab === 2 ? "black" : "gray",
                borderWidth: 0,
                width: 250,
                borderBottomRightRadius: 5,
                borderTopRightRadius: 5,
              }}
              onClick={() => {
                console.log("click");
                setTab(2);
                setNewRequests(false);
                updateAdminReadAll();
                loadRequests();
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div>Requests</div>
                {newRequests ? (
                  <div
                    style={{
                      marginLeft: 5,
                      color: "yellow",
                      fontWeight: "bold",
                    }}
                  >
                    (NEW)
                  </div>
                ) : null}
                {/* <div style={{ marginLeft:5, color: 'white', backgroundColor:'orange', padding:3, fontSize:12, width:22, height:22, borderRadius:10, textAlign:'center' }}>NEW</div> */}
              </div>
            </button>
          </div>

          {tab === 0
            ? showAssign()
            : tab === 1
              ? showAssignedUsers()
              : showRequests()}
        </div>
      </div>
      <MyLoader loader={loader} />
      <div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default AssignPrograms;
